import { render, staticRenderFns } from "./MessagesBoardWidget.vue?vue&type=template&id=4ba82b2d&scoped=true&"
import script from "./MessagesBoardWidget.vue?vue&type=script&lang=js&"
export * from "./MessagesBoardWidget.vue?vue&type=script&lang=js&"
import style0 from "./MessagesBoardWidget.vue?vue&type=style&index=0&id=4ba82b2d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ba82b2d",
  null
  
)

export default component.exports